import { CircularProgress } from '@mui/material';
import React from 'react';
import styled from 'styled-components';
import { COLORS } from '../../assets/colors';

const Loader: React.FC = () => {
  return (
    <Container>
      <CircularProgress />
    </Container>
  );
};

export default Loader;

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 72px;

  & .MuiCircularProgress-root {
    width: 24px !important;
    height: 24px !important;
    color: ${COLORS.lightBlue};
  }
`;
